import axios from "axios";
import { handleError } from "./apiUtils";
// const baseUrl = process.env.API_URL + "/users/";

// Wordpress Rest API
const baseUrl = `${window.appLocalizer.apiUrl}/wp/v2/pages`;
const nonce = window.appLocalizer.nonce;

// const baseUrl = `http://localhost/wordpress/wp-json/wp/v2/pages`;
// const nonce = `5c74968270`;
// const cookie =
//   "wordpress_test_cookie=WP Cookie check; wordpress_logged_in_bbfa5b726c6b7a9cf3cda9370be3ee91=VigneshDeva06|1641619925|mDbcLbkXx6QCfpRISDBiFZQO7lySqhkI7LYQ1NAMTNm|b7b6ab30b0dbc572397bd597fa353f2f6beb02b330988ca3c0336054c0fa071c; wp-settings-time-1=1641447151";

const headers = {
  "X-WP-NONCE": nonce,
//  Cookie: cookie,
  "Content-Type": "application/json",
};

export function getPages() {
  return axios
    .get(baseUrl, { headers, withCredentials: true })
    .then((response) => response.data)
    .catch(handleError);
}
